// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-line[data-v-9072d8cc]{width:1px;background:#ebebeb}`, "",{"version":3,"sources":["webpack://./Web/course/top_menu_vertical_line.vue"],"names":[],"mappings":"AACI,gCACI,SAAA,CACA,kBAAA","sourcesContent":["\n    .vertical-line {\n        width: 1px;\n        background: #ebebeb;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
